(function ($, window, document) {
  const $window = $(window);
  // const $document = $(document);
  // const $body = $("body");

  // Embla
  const initEmblaCarousel = () => {
    const carousels = document.querySelectorAll("[data-embla]");
    if (!carousels.length) return;

    const syncedCarousels = {};
    const emblaInstances = new Map(); // Store active Embla instances for dynamic handling

    const handleResize = () => {
      carousels.forEach((carousel) => {
        // Initialize or reinitialize the carousel
        if (!emblaInstances.has(carousel)) {
          const loop = carousel.hasAttribute("data-embla-loop");
          const syncedGroup = carousel.getAttribute("data-embla-synced");

          // Carousel instance
          const embla = EmblaCarousel(carousel, {
            loop,
            align: "start",
          });

          emblaInstances.set(carousel, embla); // Store the instance

          // Register in synced group
          if (syncedGroup) {
            if (!syncedCarousels[syncedGroup]) {
              syncedCarousels[syncedGroup] = [];
            }
            syncedCarousels[syncedGroup].push(embla);
          }

          // Progress Bar
          const progressBar = carousel.querySelector(
            "[data-embla-progress-bar]"
          );
          if (progressBar) {
            const updateProgress = () => {
              let progress = embla.scrollProgress();
              progress = Math.min(Math.max(progress, 0), 1); // Clamp progress

              progressBar.style.setProperty(
                "--embla-progress",
                `${progress * 100}%`
              );
            };

            updateProgress();
            embla.on("scroll", updateProgress);
            embla.on("resize", updateProgress);
          }

          // Pagination
          const currentPage = carousel.querySelector(
            "[data-embla-current-page]"
          );
          if (carousel.hasAttribute("data-embla-paginated") && currentPage) {
            const updateCounter = () => {
              const activeIndex = embla.selectedScrollSnap();
              currentPage.textContent = activeIndex + 1;
            };

            updateCounter();
            embla.on("select", updateCounter);
          }

          // Controls
          const prevButton = carousel.querySelector("[data-embla-prev]");
          const nextButton = carousel.querySelector("[data-embla-next]");
          prevButton.addEventListener("click", embla.scrollPrev, false);
          nextButton.addEventListener("click", embla.scrollNext, false);

          // Synchronize synced carousels
          if (syncedGroup) {
            embla.on("select", () => {
              const activeIndex = embla.selectedScrollSnap();
              syncedCarousels[syncedGroup].forEach((syncedEmbla) => {
                if (syncedEmbla !== embla) {
                  syncedEmbla.scrollTo(activeIndex);
                }
              });
            });
          }
        }
      });
    };

    // Initialize carousels and handle resizing
    handleResize();
    window.addEventListener("resize", handleResize);
  };

  // Maps
  const initMaps = () => {
    const maps = document.querySelectorAll("[data-google-map]");

    if (!maps.length) return;

    // Variable to store the currently open info window
    let currentInfoWindow = null;

    maps.forEach((map) => {
      const centerLat = parseFloat(map.getAttribute("data-lat"));
      const centerLng = parseFloat(map.getAttribute("data-lng"));
      const initialZoom = parseInt(map.getAttribute("data-zoom")) || 14;

      // Parse the JSON string to an object
      const markers = JSON.parse(map.getAttribute("data-markers"));
      const markersObj = markers.markers;

      const mapOptions = {
        center: { lat: centerLat, lng: centerLng },
        zoom: initialZoom,
        mapTypeControl: false,
        minZoom: 5,
        streetViewControl: false,
        styles: [
          {
            featureType: "administrative",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#444444",
              },
            ],
          },
          {
            featureType: "landscape",
            elementType: "all",
            stylers: [
              {
                color: "#f2f2f2",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "all",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "all",
            stylers: [
              {
                saturation: -100,
              },
              {
                lightness: 45,
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "all",
            stylers: [
              {
                visibility: "simplified",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "all",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: [
              {
                color: "#cbcbcb",
              },
              {
                visibility: "on",
              },
            ],
          },
        ],
      };

      const googleMap = new google.maps.Map(map, mapOptions);
      googleMap.setCenter(mapOptions.center);

      // Create markers
      markersObj.forEach((marker, index) => {
        const markerEl = new google.maps.Marker({
          position: new google.maps.LatLng(
            marker.position.lat,
            marker.position.lng
          ),
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            fillColor: marker.popup.type === "display" ? "#30343a" : "#87b1b0",
            fillOpacity: 1,
            strokeWeight: 0,
            scale: 11,
          },
          map: googleMap,
        });

        // Create the info window
        const infoWindowContent = `
          <div class="map__info-window">
            <button class="info-window__toggle" data-info-window-toggle>
              <svg class="toggle__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path fill="currentColor" d="M22,3.19l-1.19-1.19-8.81,8.81L3.19,2l-1.19,1.19,8.81,8.81L2,20.81l1.19,1.19,8.81-8.81,8.81,8.81,1.19-1.19-8.81-8.81L22,3.19Z"/>
              </svg>
            </button>
            <span class="info-window__eyebrow">${marker.popup.eyebrow}</span>
            <span class="info-window__heading" style="text-transform: uppercase;">${marker.popup.heading}</span>
            <span class="info-window__subheading">${marker.popup.subheading}</span>
          </div>
        `;

        const infoWindow = new google.maps.InfoWindow({
          content: infoWindowContent,
          maxWidth: 224,
          alignBottom: true,
          pixelOffset: new google.maps.Size(0, -87),
        });

        // Open the info window for the first marker
        if (index === 0) {
          infoWindow.open(googleMap, markerEl);
          currentInfoWindow = infoWindow; // Set the first info window as the current one
        }

        // Attach click listener to marker to toggle info window
        markerEl.addListener("click", () => {
          if (currentInfoWindow) {
            // Close the previously open info window
            currentInfoWindow.close();
          }

          if (infoWindow.getMap()) {
            // If the clicked info window is already open, close it
            infoWindow.close();
            currentInfoWindow = null;
          } else {
            // Otherwise, open the new info window
            infoWindow.open(googleMap, markerEl);
            currentInfoWindow = infoWindow;
          }
        });

        // Add event listener for the close button inside the info window
        google.maps.event.addListener(infoWindow, "domready", () => {
          const closeButton = document.querySelector(".info-window__toggle");
          if (closeButton) {
            closeButton.addEventListener("click", () => {
              infoWindow.close();
              currentInfoWindow = null;
            });
          }
        });
      });
    });
  };

  // Modal
  const initModals = () => {
    const modals = document.querySelectorAll("[data-modal]");
    if (!modals.length) return;

    modals.forEach((modal) => {
      const modalToggles = document.querySelectorAll(
        `[data-modal-toggle="${modal.id}"]`
      );
      const modalClose = modal.querySelector("[data-modal-close]");
      const modalOverlay = modal.querySelector("[data-modal-backdrop]");

      modalToggles.forEach((toggle) => {
        toggle.addEventListener("click", () => {
          modal.setAttribute("data-modal-open", "");
          $("body").css("overflow", "hidden");
        });
      });

      modalClose.addEventListener("click", () => {
        modal.removeAttribute("data-modal-open");
        $("body").css("overflow", "auto");
      });

      modalOverlay.addEventListener("click", () => {
        modal.removeAttribute("data-modal-open");
        $("body").css("overflow", "auto");
      });
    });
  };

  // Truncation
  const initTruncation = () => {
    const truncateElements = document.querySelectorAll("[data-truncate]");

    const updateTruncation = () => {
      truncateElements.forEach((element) => {
        const truncatedToggle = element.querySelector("[data-truncate-toggle]");

        // Check if element's scrollHeight exceeds the threshold
        if (element.scrollHeight > 400) {
          const height = element.scrollHeight;
          element.style.setProperty(
            "--truncated-expanded-height",
            `${height}px`
          );
          element.setAttribute("data-truncated", "");

          if (!truncatedToggle.hasAttribute("data-listener-attached")) {
            truncatedToggle.setAttribute("data-listener-attached", "true");
            truncatedToggle.addEventListener("click", () => {
              const expanded =
                element.getAttribute("data-truncated-expanded") === "true";

              if (expanded) {
                element.setAttribute("data-truncated-expanded", "false");
                truncatedToggle.textContent = "Read more";
              } else {
                element.setAttribute("data-truncated-expanded", "true");
                truncatedToggle.textContent = "Read less";
              }
            });
          }
        } else {
          // If content fits within the threshold, remove truncation
          element.removeAttribute("data-truncated");
          element.removeAttribute("data-truncated-expanded");
          element.style.removeProperty("--truncated-expanded-height");
          if (truncatedToggle) truncatedToggle.textContent = "";
        }
      });
    };

    // Initial truncation setup
    updateTruncation();

    // Recalculate truncation on window resize
    // window.addEventListener("resize", updateTruncation);
  };

  // Scroll to
  const initScrollTo = () => {
    const links = document.querySelectorAll("[data-scroll-to]");
    if (!links.length) return;

    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const target = link.getAttribute("data-scroll-to");
        const targetSelector = target.startsWith("#") ? target : `#${target}`;
        const targetElement = $(targetSelector);

        if (!targetElement.length) {
          console.error(`Element with selector ${targetSelector} not found.`);
          return;
        }

        $("html, body").animate(
          {
            scrollTop:
              targetElement.offset().top - $(".header__actions").outerHeight(),
          },
          800
        );
      });
    });
  };

  // Initialisations
  $window.on("load", () => {
    initEmblaCarousel();
    initMaps();
    initModals();
    initTruncation();
    initScrollTo();
  });
})(jQuery, window, document);
